import { useAppSelector } from '../../redux/hooks';
import { selectOpenedModalType } from '../../redux/selectors/modal';
import { ModalSliceType } from '../../redux/slices/modal';
import {
  DeleteScratchpadModal,
  DeleteScratchpadNoteModal,
} from './ScratchpadModals';

const ScratchpadModalController = () => {
  const isDeleteScratchpadModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DeleteScratchpad, ''),
  );
  const isDeleteScratchpadNoteModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DeleteScratchpadNote, ''),
  );

  if (isDeleteScratchpadModalOpen) {
    return <DeleteScratchpadModal />;
  }

  if (isDeleteScratchpadNoteModalOpen) {
    return <DeleteScratchpadNoteModal />;
  }

  return null;
};

export default ScratchpadModalController;
